var map = {
	"./avitela.jpg": 1055,
	"./avokado.png": 1056,
	"./bakdai1.svg": 1057,
	"./bigbox.png": 1058,
	"./bikuva.png": 1059,
	"./deinava.jpg": 1060,
	"./ermitazas.png": 1061,
	"./ln.png": 1062,
	"./maidina.png": 1063,
	"./numai.svg": 1064,
	"./oberhaus.png": 1065,
	"./senukai.png": 1066,
	"./topocentras.png": 1067,
	"./valdantis.png": 1068,
	"./varle.png": 1069
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1054;